import firebase from 'firebase/app'

export function login() {
  return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    .then(() => {
      const provider = new firebase.auth.GoogleAuthProvider()

      return firebase.auth().signInWithPopup(provider)
    })
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      // const token = result.credential.accessToken
      // The signed-in user info.

      const { email, displayName, photoURL, uid } = result.user

      return {
        email,
        name: displayName,
        avatar: photoURL,
        uid
      }
    }).catch((error) => {
      // var errorCode = error.code
      // var errorMessage = error.message
      // // The email of the user's account used.
      // var email = error.email
      // // The firebase.auth.AuthCredential type that was used.
      // var credential = error.credential

      return console.error(error)
    })
}

export function logout() {
  return firebase.auth().signOut()
    .catch((error) => console.error(error))
}
